import React from "react";
import { cn } from "../../utils/cn";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  description?: string;
  size?: "sm" | "md";
}

export function Toggle({ checked, onChange, disabled, label, description, size = "md" }: ToggleProps) {
  const track = size === "sm" ? "h-5 w-9" : "h-6 w-11";
  const thumb = size === "sm" ? "h-3.5 w-3.5" : "h-5 w-5";
  const translate = size === "sm" ? "translate-x-4" : "translate-x-5";

  const handleToggle = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <div
      onClick={handleToggle}
      className={cn("inline-flex cursor-pointer items-center gap-3 select-none", disabled && "cursor-not-allowed opacity-60")}
    >
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={handleToggle}
        className={cn(
          "relative inline-flex flex-none items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400/50",
          track,
          checked ? "bg-primary-500" : "bg-secondary-300"
        )}
      >
        <span
          className={cn(
            "absolute left-0.5 top-0.5 rounded-full bg-white shadow transition-transform pointer-events-none",
            thumb,
            checked && translate
          )}
        />
      </button>
      {(label || description) && (
        <div>
          {label ? <span className="block text-sm text-foreground-800">{label}</span> : null}
          {description ? <span className="block text-xs text-foreground-500">{description}</span> : null}
        </div>
      )}
    </div>
  );
}